import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import { Link } from "react-router-dom"

const placesListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, place) => <>{place?.id}</>,
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, place) => (
        <Link to={`/places/${place?.id}`} style={{ color: "#556ee6" }}>
          {place?.name}
        </Link>
      ),
    },
    {
      text: "Rating",
      dataField: "rating",
      formatter: (cellContent, place) => <>{place?.rating}</>,
    },
    {
      text: "Address",
      dataField: "address",
      formatter: (cellContent, place) => (
        <>
          {place?.address_street_1}, {place?.city}, {place?.state},{" "}
          {place?.country_code}
        </>
      ),
    },
  ]
}

export default placesListColumns
